var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPath(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4,
    height: 20,
    viewBox: "0 0 4 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M29.59,19.993a1.956,1.956,0,0,1-1.337-.38,1.232,1.232,0,0,1-.51-1.065V7.024a1.22,1.22,0,0,1,.489-1.092,1.951,1.951,0,0,1,1.358-.393,1.937,1.937,0,0,1,1.324.41,1.216,1.216,0,0,1,.473,1.076V18.548a1.228,1.228,0,0,1-.493,1.048A1.942,1.942,0,0,1,29.59,19.993Zm0-16.776a2.236,2.236,0,0,1-1.43-.468,1.44,1.44,0,0,1,.007-2.3,2.468,2.468,0,0,1,2.847,0A1.462,1.462,0,0,1,31.589,1.6a1.484,1.484,0,0,1-.576,1.158A2.237,2.237,0,0,1,29.59,3.217Z",
    transform: "translate(-27.59 0.002)",
    fill: "#dadada"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath);
export default __webpack_public_path__ + "static/media/Path.740cb237a56da20492063486852272f4.svg";
export { ForwardRef as ReactComponent };